import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class ContactLessTxnIssuerFilter extends Component {
    state = {
        txnissuerLists:[],
        txnissuerValue: '',
        isTxnIssuerLoading: true
    };
    componentDidMount(){
        this._txn_issuer_bank(this.props.start_date,this.props.end_date);
    }
//     resetCard()
//     {
//         this.setState({
//             cardTypeValue: [],
//         })
//     }
    _txn_issuer_bank(start_date, end_date){
        this.setState({
            txnissuerLists:[],
            txnissuerValue: [],
            isTxnIssuerLoading: true
        })
        axios.post(config.get('API_URL')+'/reports/txn-contactless-issuer-bank/',{
                yestSend: start_date,
                todSend: end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    txnissuerLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((txn_issure, index) => {
                    this.state.txnissuerLists.push({value: txn_issure.issuing_bank_name, label: txn_issure.issuing_bank_name})
                });
            }
            this.setState({
                isTxnIssuerLoading: false
            })
        });

    }


    change_issuer(optionSelected){
        let value='';
        let issuArray = [];
        if(optionSelected.length < 1){
            value = null;
            issuArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                issuArray.push(mids.value)
                var index = this.state.txnissuerLists.findIndex(obj => obj.value==mids.value);
                this.state.txnissuerLists.move(index,0).join(',');
            });
        }

        this.props.onSelectTxnIssuer(optionSelected, issuArray);
        this.setState({
            txnissuerValue:optionSelected,
        });
    }
    render() {
        return (
            <ReactMultiSelectCheckboxes name="issuer"
                isMulti
                value={this.state.txnissuerValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.change_issuer.bind(this)}
                options={this.state.txnissuerLists}
                placeholderButtonLabel="Select [issuer]"
                isLoading={this.state.isTxnIssuerLoading}
            />
        );

    }
}
export default ContactLessTxnIssuerFilter;